/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { VideoSurveySubmissionInputAnswersItem } from './videoSurveySubmissionInputAnswersItem'
import type { VideoSurveySubmissionInputScenarioId } from './videoSurveySubmissionInputScenarioId'

/**
 * 動画詳細ページからのフォーム一括送信（PII 混在）。
 */
export interface VideoSurveySubmissionInput {
  answers: VideoSurveySubmissionInputAnswersItem[]
  /** @nullable */
  scenarioId?: VideoSurveySubmissionInputScenarioId
  sessionId: string
}
